module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent()
      }
    }
  }, [_vm._v("新增")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-1afbc36a"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myButton/AddButton.vue
// module id = 1879
// module chunks = 1